<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <topIcon :template="dominItem?.templateId" :nationId="dominItem.nationId"></topIcon>
    </div>
    <div>
      <div class="logo" :class="[`${dominItem?.templateId}`, `${dominItem?.templateId}1`]">{{ dominItem?.logoName || 'Logo' }}</div>
      <div class="category" :class="`${dominItem?.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 20%;">
      <div class="page-container">
        <!-- 左侧业务板块 -->
        <div class="business-section">
          <h2 class="section-title business-title">{{ $t('con_recommended') }}</h2>
          <div class="main-article" @click="toDetail(bestItem.articleShortName)" v-if="bestItem">
            <img :src="bestItem?.articleImage" class="main-article-img" >
            <h3 class="main-article-heading twoHde">{{ bestItem?.articleTitle }}</h3>
            <p class="main-article-desc threeHde">
              {{ bestItem?.articleIntro }}
            </p>
          </div>
          <div class="sub-articles">
            <div class="sub-article" v-for="item in recommendList" @click="toDetail(item.articleShortName)">
              <img
                  :src="item?.articleImage"
                  class="sub-article-img"
              >
              <h4 class="twoHde">{{ item?.articleTitle }}</h4>
              <p class="threeHde">{{ item?.articleIntro }}</p>
            </div>
          </div>
        </div>
        <!-- 右侧新闻板块 -->
        <div class="news-section">
          <h2 class="section-title business-title">{{ $t('con_hot_con') }}</h2>
          <div class="news-article" v-for="item in latestNewsList" @click="toDetail(item.articleShortName)">
            <img
                :src="item?.articleImage"
                class="news-article-img"
            >
            <h3  class="twoHde">{{ item?.articleTitle }}</h3>
            <p class="threeHde">{{ item?.articleIntro }}</p>
          </div>
        </div>
      </div>

      <div class="marketing-lifestyle-page">
        <!-- 左侧 MARKETING 板块 -->
        <div class="marketing-section">
          <h2 class="section-title business-title">{{ $t('con_related') }}</h2>

          <div class="marketing-article" v-for="item in recommendList1" @click="toDetail(item.articleShortName)">
            <img
                :src="item?.articleImage"
                class="article-img"
            >
            <h3 class="twoHde">{{ item?.articleTitle }}</h3>
            <p class="threeHde">{{ item?.articleIntro }}</p>
          </div>
        </div>
<!--        &lt;!&ndash; 右侧 LIFESTYLE 板块 &ndash;&gt;-->
        <div class="lifestyle-section">
          <h2 class="section-title business-title">{{ $t('con_latest') }}</h2>
          <div class="lifestyle-article" v-for="item in articleList" @click="toDetail(item.articleShortName)">
            <img
                :src="item?.articleImage"
                class="article-img"
            >
            <h3 class="twoHde">{{ item?.articleTitle }}</h3>
            <p class="threeHde">{{ item?.articleIntro }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div style="display: flex">
        <div class="logo">{{ dominItem?.logoName || 'Logo' }}</div>
        <div class="explore">
          <span>{{ $t('con_Explore') }}</span>
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>

          <buttomIcon v-if="dominItem.nationId !== 'cn'"></buttomIcon>

        </div>
      </div>
      <footers :articleListlast="articleListlast" :current="current"></footers>

    </div>
  </div>
</template>

<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName} from "@/api"
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList:[],
      latestNewsList:[],
      articleList:[],
      articleListlast:[],
      recommendList1: [],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId || 'en'
    
    
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getOneList()
    }
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 5, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows


        console.log(this.articleList, 'articleListarticleList');
        // this.articleList.map(r => {
        //   // r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        // })
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 6, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 10,

        articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
          this.recommendList = res.rows
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 4, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.page-container {
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #B0B0B0;

  // 让页面有一定间距，可根据需求调整
  .business-section {
    padding-bottom: 50px;
    width: 70%;
  }

  .business-section,
  .news-section {
    &-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 15px;
      padding: 5px 10px;
      display: inline-block;
      border-radius: 4px;
    }
  }

  .news-title {
    background-color: #0066cc;
    color: white;
  }

  .main-article {
    margin-bottom: 30px;

    .main-article-img {
      width: 100%;
      height: auto;
      margin-bottom: 10px;
    }

    .main-article-heading {
      font-size: 22px;
      margin-bottom: 10px;
    }

    .main-article-desc {
      line-height: 1.6;
    }
  }

  .sub-articles {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .sub-article {
      width: calc(50% - 10px);
      // 每行两个，留出间距
      .sub-article-img {
        width: 100%;
        height: 200px;
        margin-bottom: 10px;
      }

      h4 {
        font-size: 18px;
        margin-bottom: 5px;
      }

      p {
        line-height: 1.4;
      }
    }
  }

  .news-section {
    width: 30%;
    // 右侧新闻板块宽度，可按需调整
    .news-article {
      margin-bottom: 30px;

      .news-article-img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }

      h3 {
        font-size: 18px;
        margin-bottom: 5px;
      }

      p {
        line-height: 1.4;
      }
    }
  }
}

.marketing-lifestyle-page {
  display: flex;
  margin-top: 50px;
  justify-content: space-between;
  gap: 20px;

  .marketing-section {
    width: 70%;
  }

  .marketing-section,
  .lifestyle-section {
    &-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 15px;
      padding: 5px 10px;
      display: inline-block;
      border-radius: 4px;
    }
  }

  .marketing-title {
    background-color: #003366;
    color: white;
  }

  .lifestyle-title {
    background-color: #0066cc;
    color: white;
  }

  .marketing-article,
  .lifestyle-article {
    margin-bottom: 30px;

    .article-img {
      width: 100%;
      height: auto;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 5px;
    }

    p {
      line-height: 1.4;
    }
  }

  .lifestyle-section {
    width: 30%;
    // 右侧生活方式板块宽度，可按需调整
  }
}

.business-title {
  background-color: #003366;
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  width: 60%;
  padding: 10px;
  box-sizing: border-box;
  font-size: 40px;
  font-weight: bold;
  text-align: left;
  margin-left: 20%;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  padding: 0 20%;
  min-height: 50px;
  background: #042464;
  margin-bottom: 30px;
  color: #fff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    border-bottom: 3px solid red;
    color: red;
    transition: all .1s ease;
  }

  .choose {
    border-bottom: 3px solid red;
    transition: all .1s ease;
    color:red;
  }
}

.buttom {
  border-top: 5px solid #042464;
  background: #EDF3FF;
  display: flex;
  flex-direction: column;

  .logo {
    margin: 0 3% 0 10%;
    width: auto;
  }

  display: flex;

  .explore {
    display: flex;

    align-items: center;

    span:first-child {
      color: #042464;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #042464;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

</style>